export default {
  dateFormat: (fmt, date) => {
    if (!date) {
      return '-'
    }
    date = new Date(date)
    let ret
    const opt = {
      'Y+': date.getFullYear().toString(), // 年
      'm+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'H+': date.getHours().toString(), // 时
      'M+': date.getMinutes().toString(), // 分
      'S+': date.getSeconds().toString() // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
    }
    for (const k in opt) {
      ret = new RegExp('(' + k + ')').exec(fmt)
      if (ret) {
        fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
      }
    }
    return fmt
  },
  AddDayToDate (Time, days) {
    var a = new Date(Time)
    a = a.valueOf()
    a = a + days * 24 * 60 * 60 * 1000
    a = new Date(a)
    return a
  }
}
